import { Component, OnDestroy, OnInit, Input, PLATFORM_ID, Inject } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subject } from 'rxjs';
import { filter, startWith, takeUntil } from 'rxjs/operators';
import * as fromHeader from '../../store';
import { MediaObserver } from '@angular/flex-layout';
import * as fromUserInfoSelectors from '~shared/modules/user-info/store/user-info.selectors';
import { IAccountInformation } from '~shared/models/account-information.model';
import { MobileMenuService } from '~app/modules/generic/services/mobile-menu.service';
import { CachedCategoriesUtil } from '~app/modules/generic/utils/cached-categories.util';
import { MEDIA_ALISES } from '~shared/constants/media.constant';
import { UrlUtils } from '../../utils/url.utils';
import { NavigationEnd, Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';

@Component({
  selector: 'app-generic-buyer-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit, OnDestroy {
  @Input() isUserBlocked: boolean;

  private destroySubject$ = new Subject<boolean>();
  showSecondaryHeader = true;

  user$: Observable<IAccountInformation> = this.store.pipe(
    select(fromUserInfoSelectors.getUserData),
    takeUntil(this.destroySubject$)
  );
  isSearchInputFocused$ = this.store.pipe(select(fromHeader.isSearchInputFocused));
  isSuggestionsListVisible$ = this.store.pipe(select(fromHeader.isSearchSuggestionsListVisible));
  isDesktop = false;
  isWideScreen = false;

  constructor(
    private store: Store<fromHeader.BuyerState>,
    private mediaObserver: MediaObserver,
    private mobileMenuService: MobileMenuService,
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.subscribeToMediaObserver();

    if (isPlatformBrowser(this.platformId)) {
      this.router.events
        .pipe(
          filter<NavigationEnd>((event: any) => event instanceof NavigationEnd),
          startWith(this.router)
        )
        .subscribe((event) => {
          this.showSecondaryHeader = !UrlUtils.getIsEmployeeRestrictedView(event.url);
        });
    }
  }

  ngOnInit() {
    if (!CachedCategoriesUtil.isCachedCategoriesExisted()) {
      this.store.dispatch(new fromHeader.LoadCategories());
    }
  }

  ngOnDestroy(): void {
    this.destroySubject$.next();
    this.destroySubject$.complete();
  }

  hideMobileMenu() {
    this.mobileMenuService.close();
  }

  private subscribeToMediaObserver(): void {
    this.mediaObserver
      .asObservable()
      .pipe(takeUntil(this.destroySubject$))
      .subscribe(() => {
        this.isDesktop = this.mediaObserver.isActive(MEDIA_ALISES.desktop);
        this.isWideScreen = this.mediaObserver.isActive(MEDIA_ALISES.tablet);
        if (this.isDesktop) {
          this.hideMobileMenu();
        }
      });
  }
}
